export default __webpack_public_path__ + "static/media/HDTX_KI Tambhn dan atau Perbhn_Buyback Delisting 2025.96266826.pdf";